import { Divider, FormControl, MenuItem, Stack } from "@mui/material";
import {
  Img,
  Input,
  Link,
  LoadingSkeleton,
  Row,
  Select,
  XsText,
  XsTextSemiBold,
} from "Components";
import { DIRECT_PATHS } from "constants/routes";
import useGetData from "hooks/useGetData";
import { Fragment, useMemo } from "react";
import { Controller } from "react-hook-form";
import { useIntl } from "react-intl";
import { apiGetAllUOM } from "services/api/helpers";
import { formatImgUrl } from "utils/helpers";

type Props = {
  isLoading: boolean;
  control: any;
  setValue: any;
  farm_item_id: string;
  unit: string;
  register: any;
  farm_item_data: any;
};

const InquiryItem = (props: Props) => {
  const intl = useIntl();
  const {
    isLoading,
    control,
    setValue,
    farm_item_id,
    unit,
    register,
    farm_item_data,
  } = props;
  const { data: uomData } = useGetData({
    promise: () => {
      if (farm_item_id) {
        return apiGetAllUOM();
      }
    },
  });

  const uoms = useMemo(() => {
    let newUoms = (uomData?.data || []).map((uom: any) => ({
      label: uom?.uom_name,
      value: uom?.name,
    }));
    if (newUoms?.length > 0 && farm_item_id && !unit) {
      setValue("unit", newUoms[0]?.value);
    }
    return newUoms;
  }, [uomData?.data]);

  return (
    <>
      <Divider />
      <Row direction={{ xs: "column", md: "row" }}>
        <Stack direction="row" alignItems="center" className="info-box">
          {isLoading ? (
            <LoadingSkeleton count={1} sx={{ py: 2 }} alignItems="flex-start" />
          ) : (
            <>
              <Img
                src={formatImgUrl(farm_item_data?.farm_item_image, 2)}
                alt="img"
              />
              <Link
                to={DIRECT_PATHS.itemDetail(farm_item_data?.farm_item)}
                target="_blank"
              >
                <XsTextSemiBold p={1}>
                  {farm_item_data?.farm_item_name}
                </XsTextSemiBold>
              </Link>
            </>
          )}
        </Stack>

        <Row width="100%" flex={1}>
          <Input
            className="input"
            {...register("quantity")}
            placeholder={intl.formatMessage({ id: "Quantity" })}
          />
          <FormControl className="input">
            <Controller
              control={control}
              name="unit"
              render={({ field }) => (
                <Select {...field}>
                  {uoms?.map((uom: any) => (
                    <MenuItem key={uom?.value} value={uom?.value}>
                      {uom?.label}
                    </MenuItem>
                  ))}
                </Select>
              )}
            />
          </FormControl>
        </Row>
      </Row>

      {(farm_item_data?.attr || []).length > 0 && (
        <XsText className="attributes cutoff-text twoline" mt={2}>
          {farm_item_data?.attr?.map((data: any) => (
            <Fragment key={data.key}>
              {data.key}: <span>{data.value}</span>
              {"  "}
            </Fragment>
          ))}
        </XsText>
      )}
    </>
  );
};

export default InquiryItem;
